import {
  Tooltip,
  Grid,
  Button,
  Box,
  IconButton,
  Typography,
  makeStyles,
  Close,
} from '@quillbot/design-system';
import React, { useEffect, useState } from 'react';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { RootState } from '@Common/models/redux/store';
import { QUILLPRODUCTS } from '@Common/models';
import { useSelector } from 'react-redux';
import Track from '@Common/handlers/track';
import Link from 'next/link';

const useStyles = makeStyles((theme) => ({
  closeIcon: {
    fontSize: '16px',
    color: theme.palette.grey[50],
  },
  productUpSellTooltip: {
    width: '180px',
    padding: '12px',
  },
}));

interface IPprops {
  rewriteTextClickHandler: Function;
}

function ParaphraseText(props: IPprops) {
  const classes = useStyles();
  const [openProductUpsellTooltip, setOpenProductUpsellTooltip] =
    useState(false);
  const crossProductUpsell = useSelector(
    (state: RootState) => state?.common?.crossProductUpsell
  );

  useEffect(() => {
    if (
      crossProductUpsell === QUILLPRODUCTS.PARAPHRASER &&
      QuillLocalStorage.getInstance().get('pphrUpsell', 'false') === 'false'
    ) {
      setOpenProductUpsellTooltip(true);
      Track.interactedCrossProductUpsellModal(
        QUILLPRODUCTS.PARAPHRASER,
        'shown'
      );
    }
  }, [crossProductUpsell]);

  const userInteractedWithPphrUpsell = () => {
    QuillLocalStorage.getInstance().set('pphrUpsell', 'true');
    setOpenProductUpsellTooltip(false);
  };

  const closeUpsellTooltip = () => {
    Track.interactedCrossProductUpsellModal(
      QUILLPRODUCTS.PARAPHRASER,
      'closed'
    );
    userInteractedWithPphrUpsell();
  };

  const tooltipBlock = (
    <>
      <Box
        display="flex"
        position="absolute"
        right="4px"
        top="4px"
        justifyContent="flex-end"
      >
        <IconButton
          sx={{ padding: '0' }}
          onClick={closeUpsellTooltip}
          size="small"
        >
          <Close className={classes.closeIcon} />
        </IconButton>
      </Box>

      <Box>
        <Typography color="grey.50" fontSize="14px" lineHeight="18px">
          Rephrase your text to enhance your writing.
        </Typography>
      </Box>
    </>
  );

  return (
    <Tooltip
      classes={{
        tooltip: classes.productUpSellTooltip,
      }}
      arrow
      open={openProductUpsellTooltip}
      placement="top"
      title={tooltipBlock}
    >
      <Grid item>
        <Link to="/">
          <Button
            onClick={() => {
              userInteractedWithPphrUpsell();
              Track.interactedCrossProductUpsellModal(
                QUILLPRODUCTS.PARAPHRASER,
                'accepted'
              );
              props.rewriteTextClickHandler();
            }}
            style={{
              borderRadius: '100px',
              paddingLeft: '14px',
              paddingRight: '14px',
              fontWeight: 600,
              fontSize: '14px',
            }}
            variant="outlined"
            color="primary"
          >
            Paraphrase Text
          </Button>
        </Link>
      </Grid>
    </Tooltip>
  );
}

export default ParaphraseText;
